import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export const Results = () => {
  const { t } = useLang();
  return (
    <section
      id="results"
      data-testid="results-section"
      className="relative border-y border-slate-300/60 bg-slate-200/50 py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-14 max-w-2xl"
        >
          <div className="font-mono-alt mb-4 text-xs uppercase tracking-[0.25em] text-blue-700">
            {t.results.eyebrow}
          </div>
          <h2 className="font-display text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            {t.results.title} <span className="text-glow-gradient">{t.results.titleAccent}</span>
            <sup className="ml-1 text-blue-700" data-testid="results-asterisk">*</sup>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-6">
          {t.results.metrics.map((m, i) => (
            <motion.div
              key={m.label}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`result-metric-${i}`}
              className={`group rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-blue-300 hover:shadow-[0_16px_40px_rgba(29,78,216,0.10)] sm:p-8 ${
                i < 2 ? "lg:col-span-3" : "lg:col-span-2"
              }`}
            >
              <div className="font-display text-3xl font-extrabold tracking-tight text-blue-700 sm:text-4xl lg:text-5xl">
                {m.value}
              </div>
              <div className="mt-4 h-px w-10 bg-teal-500 transition-all duration-300 group-hover:w-16" />
              <p className="mt-4 text-sm font-normal leading-relaxed text-slate-700 sm:text-base">{m.label}</p>
            </motion.div>
          ))}
        </div>
        <p data-testid="results-footnote" className="mt-8 text-sm italic text-slate-500">
          {t.results.footnote}
        </p>
      </div>
    </section>
  );
};
